import type { AbnVariationRef } from './types';

const BASE_URL = '/web/studio/abn-testing';

export const abnInstancesUrl = () => `${BASE_URL}/instances`;

export const abnInstanceExperimentsUrl = (instanceName: string) =>
  `${abnInstancesUrl()}/${encodeURIComponent(instanceName)}/experiments`;

export const abnExperimentUrl = (instanceName: string, experimentId: string) =>
  `${abnInstanceExperimentsUrl(instanceName)}/${encodeURIComponent(experimentId)}`;

export const abnVariationTranslationsUrl = (ref: AbnVariationRef) =>
  `${abnExperimentUrl(ref.instanceName, ref.experimentId)}/variations/${encodeURIComponent(
    ref.variationId
  )}/translations`;

export const abnLocaleTranslationsUrl = (ref: AbnVariationRef, locale: string) =>
  `${abnVariationTranslationsUrl(ref)}/${encodeURIComponent(locale)}`;

/* eslint-disable camelcase */
export const abnVariationQuery = (ref: AbnVariationRef) => ({
  experiment_name: ref.experimentName,
  variation_name: ref.variationName,
});
/* eslint-enable camelcase */
